import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from "@ngrx/store";
import * as fromToolbar from "./state/toolbar.reducer";
import { EffectsModule } from "@ngrx/effects";
import { ToolbarEffects } from "./state/toolbar.effects";
import { ToolbarSignalrSyncEffects } from "./state/toolbar-signalr-sync.effects";

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature(
            fromToolbar.toolbarFeatureKey,
            fromToolbar.reducer
        ),
        EffectsModule.forFeature([ToolbarEffects, ToolbarSignalrSyncEffects]),
    ],
})
export class SharedClassroomToolbarDataAccessModule {}
